import { GET_CHAT_LIST, UPDATE_CHAT_LAST_MESSAGE } from "../actions/types";

const initialState = {
  channelList: [],
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {

    case GET_CHAT_LIST:
      return {
        ...state,
        channelList: payload,
      };

    case UPDATE_CHAT_LAST_MESSAGE:
      return {
        ...state,
        channelList: state.channelList.map(c =>
          c.chat._id === payload.chatId
            ? { ...c, lastMessage: payload.lastMessage }
            : c
        ),
        // setChats(prev =>
        //   prev.map(c =>
        //     c.chat._id === msg.chat ? { ...c, lastMessage: msg } : c
        //   )
        // );
      };
    default:
      return state;
  }
}
